var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuotesLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M25.854 8.866h-.442V7.369a3.115 3.115 0 0 0-3.2-3.03h-2.268v-.367a3.115 3.115 0 0 0-3.182-3.03H6.146a3.115 3.115 0 0 0-3.181 3.03v1.675a.941.941 0 1 0 1.826 0V3.972a1.299 1.299 0 0 1 1.355-1.205h10.616a1.299 1.299 0 0 1 1.356 1.205v.367h-8.33a3.115 3.115 0 0 0-3.2 3.03v1.826a.941.941 0 0 0 1.883 0V7.37a1.29 1.29 0 0 1 1.317-1.204h12.424a1.29 1.29 0 0 1 1.364 1.204v1.497h-9.543a3.115 3.115 0 0 0-3.19 3.03v1.883a.941.941 0 0 0 1.825 0v-1.883a1.29 1.29 0 0 1 1.365-1.204h11.821a1.29 1.29 0 0 1 1.355 1.204v16.132a1.299 1.299 0 0 1-1.355 1.205H14.033a1.299 1.299 0 0 1-1.365-1.205V17.412a.941.941 0 0 0-1.826 0v6.73H9.788a1.299 1.299 0 0 1-1.317-1.215V13.44a.941.941 0 0 0-1.826 0v6.174h-.5A1.299 1.299 0 0 1 4.792 18.4V9.195a.941.941 0 0 0-1.826 0V18.4a3.115 3.115 0 0 0 3.18 3.04h.443v1.487a3.125 3.125 0 0 0 3.2 3.04h1.054v2.061a3.125 3.125 0 0 0 3.19 3.03h11.822a3.115 3.115 0 0 0 3.181-3.03V11.896a3.115 3.115 0 0 0-3.18-3.03zm-9.167 8.075c0 2.07 1.732 2.824 3.238 3.21 1.882.498 2.23 1.1 2.24 1.882 0 .941-.744 1.525-2.043 1.534-1.826 0-2.014-1.045-2.033-1.176a.687.687 0 0 0-.743-.603.668.668 0 0 0-.621.734 2.824 2.824 0 0 0 2.739 2.363v1.468a.687.687 0 1 0 1.374 0v-1.44a2.824 2.824 0 0 0 2.72-2.824c0-2.089-1.742-2.823-3.247-3.228-1.883-.508-2.222-1.082-2.231-1.882 0-.941.762-1.544 2.042-1.553 1.826 0 2.014 1.054 2.033 1.167a.692.692 0 0 0 1.374-.16 2.824 2.824 0 0 0-2.757-2.315v-1.469a.687.687 0 0 0-.687-.677.706.706 0 0 0-.687.687v1.459a2.88 2.88 0 0 0-2.71 2.823z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotesLight);
export default __webpack_public_path__ + "static/media/icon-quotes-light.f7ee4593bb11f8494eaf924594da00c0.svg";
export { ForwardRef as ReactComponent };